import { httpsCallable } from 'firebase/functions';
import { functions } from '../constants/firebaseModular';
import { AutomatedEmailPayload } from '../types/Email/AutomatedEmailPayload';
import { AutomatedEmailResponse } from '../types/Email/AutomatedEmailResponse';
import * as Sentry from '@sentry/browser';

export const sendAutomatedEmail = async (payload: AutomatedEmailPayload) => {
  // CHECK FOR REQUIRED FIELDS
  if (!payload.email || !payload.name || !payload.patientId || !payload.type) {
    Sentry.captureMessage(`Missing required fields in payload ${JSON.stringify(payload)}`);
    return;
  }

  // IF ALL CONDITIONS MET, CALL CLOUD FUNCTION TO SEND EMAIL
  const postToCloudFunction = httpsCallable(functions, 'sendAutomatedEmail') as (
    // eslint-disable-next-line
    payload: AutomatedEmailPayload,
  ) => Promise<AutomatedEmailResponse>;

  postToCloudFunction(payload)
    .then(async (response) => {
      if (response.data.status === 'error') {
        Sentry.captureMessage(`Error sending email with MailGun:  ${response.data.message}`);
        return;
      }
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      Sentry.captureException(error);
      console.error('Error calling cloud function', errorCode, errorMessage);
    });
};
